module.exports = __webpack_public_path__ + "static/media/sleep.bf4f1467.jpg";